import { createStore, applyMiddleware, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';

import { loadAuthToken } from './local-storage';
import { setAuthToken } from './actions/auth';
import authReducer from './reducers/auth';
import matchupsReducer from './reducers/matchups';
import usersReducer from './reducers/users';

const store = createStore(
  combineReducers({
    form: formReducer,
    auth: authReducer,
    matchups: matchupsReducer,
    users: usersReducer
  }),
  applyMiddleware(thunk)
);

const authToken = loadAuthToken();
if (authToken) {
  const token = authToken;
  store.dispatch(setAuthToken(token));
}

export default store;


// WEBPACK FOOTER //
// ./src/store.js